export class LoginErrorsModel {

    constructor() {}

}
